import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { Store } from '@app/config/store';
import { email } from '@app/dto/common.dto';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { matRemoveRedEye, matVisibilityOff } from '@ng-icons/material-icons/baseline';
import { matDeleteOutlineOutline } from '@ng-icons/material-icons/outline';
import { AdminAuthService } from '@app/services/admin-auth.service';
import { PartnerStore } from '@app/config/partner-store';
import { EncryptionService } from '@app/services/encrytion.service';

@Component({
  selector: 'app-admin-login',
  standalone: true,
  imports: [RouterModule, ReactiveFormsModule, NgIconComponent, CommonModule],
  providers: [provideIcons({ matDeleteOutlineOutline, matRemoveRedEye, matVisibilityOff })],
  templateUrl: './admin-login.component.html',
  styleUrl: './admin-login.component.css',
})
export class AdminLoginComponent {
  redirectURL: string = '';
  passwordFieldType: string = 'password';

  loginForm: FormGroup = new FormGroup({
    userId: new FormControl('', [email]),
    password: new FormControl('', []),
  });

  constructor(
    private router: Router,
    protected store: Store,
    private authSvc: AdminAuthService,
    private partnerStore: PartnerStore,
    private encrypt: EncryptionService,
  ) {
    const redirectUrl = this.router.parseUrl(this.router.url).queryParams['redirectUrl'];

    if (redirectUrl && redirectUrl !== '') sessionStorage.setItem('redirectUrl', redirectUrl);

    this.redirectURL = sessionStorage.getItem('redirectUrl') ?? '';
    sessionStorage.removeItem('redirectUrl');
  }

  async login(): Promise<void> {
    const payload = this.loginForm.value;
    payload.password = await this.encrypt.encryptWithPublicKey(payload.password as string);
    this.authSvc.login(payload).subscribe((resp) => {
      if (resp) {
        this.partnerStore.setAuthToken(resp.token);
        this.partnerStore.setUserInfo({ email: resp.userEmail, name: resp.userName });
        const query = this.redirectURL !== '' ? { redirectUrl: this.redirectURL } : {};
        this.router.navigate(['/admin-redirect'], { queryParams: query });
      }
    });
  }

  togglePasswordVisibility() {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
  }
}
